/* Smart Business: RUC required, native Shopify email, confirmed Sheets write and manual WhatsApp hand-off. */
(function () {
  'use strict';
  function start() {
    document.querySelectorAll('[data-sbv-root]').forEach(function (root) {
      if (root.dataset.sbvReady) return;
      root.dataset.sbvReady = '8';
      var form = root.querySelector('form'), fieldsBox = root.querySelector('[data-sbv-fields]');
      var variants = [], trigger = null, record = null, busy = false, nativePass = false, purgeTimer, emailTimer;
      var ttl = 20 * 60 * 1000, storageKey = 'sb-volume-quote-v2:' + root.dataset.product;
      var endpoint = (root.dataset.sheetsEndpoint || '').trim();
      var submitButton = form.querySelector('.sbv__submit'), submitLabel = submitButton.textContent;
      var keys = ['name','email','phone','quantity','company','ruc','city','notes','product','sku','barcode','variant','url','reference','date_lima','consent','purchase_date','contact_method','notes_input'];
      try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) {}
      function field(k) { return root.querySelector('[data-sbv-field="' + k + '"]'); }
      var contactOptions = ['CORREO','WHATSAPP','LLAMADA'];
      function selectedContactMethods() {
        return Array.prototype.filter.call(root.querySelectorAll('[data-sbv-contact-method]'), function (box) {
          return box.checked && contactOptions.indexOf(box.value) >= 0;
        }).map(function (box) { return box.value; });
      }
      function get(k) { var el = field(k); return !el ? '' : el.type === 'checkbox' ? (el.checked ? el.value : '') : el.value.trim(); }
      function put(k, value) {
        var el = field(k); if (!el) return;
        if (k === 'contact_method') {
          // Accept previous single-choice sessions and current comma-separated values.
          // Keep one consolidated contact field for Shopify and the existing receiver.
          var selected = String(value == null ? '' : value).split(',').map(function (v) { return v.trim(); });
          root.querySelectorAll('[data-sbv-contact-method]').forEach(function (box) {
            box.checked = selected.indexOf(box.value) >= 0;
          });
          el.value = selectedContactMethods().join(', ');
        } else if (el.type === 'checkbox') el.checked = Boolean(value);
        else el.value = String(value == null ? '' : value);
      }
      function notice(text) { root.querySelector('[data-sbv-status]').textContent = text; }
      // Keep the original receiver contract: purchase details travel inside the
      // notes/message columns, with separate values retained in this tab.
      function dateLabel(iso) {
        if (!iso) return 'No indicada';
        var m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(iso);
        if (!m) return null;
        var d = new Date(iso + 'T12:00:00Z');
        if (!Number.isFinite(d.getTime()) || d.toISOString().slice(0,10) !== iso) return null;
        return m[3] + '/' + m[2] + '/' + m[1];
      }
      function restoreFields() {
        if (!record) return;
        keys.forEach(function (k) { put(k,record.fields[k]); });
        // A saved v6 request must keep its original body and integrity hash.
        if (typeof record.fields.notes_input !== 'string') put('notes_input',record.fields.notes || '');
      }
      function preparePurchaseDetails() {
        var date = dateLabel(get('purchase_date')), method = selectedContactMethods().join(', ');
        put('contact_method',method);
        var notes = get('notes_input');
        field('purchase_date').setCustomValidity(date !== null ? '' : 'Selecciona una fecha válida.');
        var combined = (notes || 'No indicadas') + '\n\nFecha de compra: ' + (date || 'No indicada') + '\nMedio de contacto preferido: ' + (method || 'No indicado');
        field('notes_input').setCustomValidity(combined.length <= 1000 ? '' : 'Reduce las observaciones para incluir también la fecha y el medio de contacto (máximo 900 caracteres de observaciones).');
        put('notes',combined);
      }

      function forget() { try { sessionStorage.removeItem(storageKey); } catch (e) {} }
      function persist() {
        try { sessionStorage.setItem(storageKey, JSON.stringify(record)); clearTimeout(purgeTimer); purgeTimer = setTimeout(forget, Math.max(0,ttl - (Date.now() - record.time))); return true; }
        catch (e) { notice('Para conservar todos los datos al continuar por WhatsApp, permite el almacenamiento de sesión de este sitio y vuelve a enviar.'); return false; }
      }
      function read() {
        try {
          var x = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
          if (x && x.product === root.dataset.product && x.time <= Date.now() && Date.now() - x.time < ttl && typeof x.message === 'string' && x.message.length < 12000 && x.fields && /^[0-9]{11}$/.test(x.fields.ruc)) return x;
        } catch (e) {}
        forget(); return null;
      }
      function randomId() {
        var a = new Uint8Array(16); window.crypto.getRandomValues(a);
        return Array.from(a, function (v) { return v.toString(16).padStart(2, '0'); }).join('');
      }
      function info() { return document.querySelector('.template-product .product__info-container'); }
      function sync(copyQuantity) {
        var i = info(), input = i && i.querySelector('product-form input[name="id"]');
        var id = input && input.value || root.dataset.variant;
        var v = variants.find(function (x) { return String(x.id) === String(id); }) || variants[0] || {};
        put('product', root.dataset.title); put('sku', v.sku); put('barcode', v.barcode);
        put('variant', v.title === 'Default Title' ? 'Estándar' : (v.title || 'Estándar'));
        var url = new URL(root.dataset.url, location.origin);
        if (v.id) url.searchParams.set('variant', v.id);
        put('url', url.href);
        root.querySelector('[data-sbv-identity]').textContent = 'SKU: ' + (v.sku || 'No registrado') + (v.barcode ? ' · Código: ' + v.barcode : '') + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
        if (copyQuantity) {
          var q = i && i.querySelector('.product-form__quantity input[name="quantity"]');
          if (q && Number.isSafeInteger(Number(q.value)) && Number(q.value) > 0) put('quantity', q.value);
        }
      }
      function reveal(focus) {
        root.hidden = false; if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (focus) { root.scrollIntoView({block:'start',behavior:'auto'}); (root.dataset.sbvCompleted === 'true' ? root.querySelector('[data-sbv-success-title]') : root.querySelector('h2')).focus({preventScroll:true}); }
      }
      function close() {
        root.hidden = true;
        if (trigger) { trigger.setAttribute('aria-expanded','false'); trigger.focus({preventScroll:true}); }
      }
      function bind() {
        var i = info(); if (!i) return;
        var a = i.querySelector('.sb-ob-vol a') || Array.prototype.find.call(i.querySelectorAll('.ishi-progress-content a[href*="whatsapp"]'), function (x) { return /volumen/i.test(x.textContent); });
        if (!a) return; trigger = a;
        if (!a.dataset.sbvToggle) {
          a.dataset.sbvToggle = '1'; a.href = '#' + root.id; a.removeAttribute('target'); a.removeAttribute('onclick');
          a.setAttribute('role','button'); a.setAttribute('aria-controls',root.id); a.setAttribute('aria-expanded',String(!root.hidden));
          a.setAttribute('aria-label','Abrir formulario de cotización por volumen');
          a.innerHTML = '<svg class="sbv__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M7 3h7l4 4v14H5V3h2Z"/><path d="M14 3v5h4M8 12h7M8 16h7"/></svg><span>Cotiza por volumen</span>';
          a.addEventListener('click', function (e) { e.preventDefault(); if (root.hidden) { if (!record) sync(true); reveal(true); } else close(); });
          a.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); a.click(); } });
        }
        var anchor = i.querySelector('.sb-ob-actions') || i.querySelector('.buy-btn-space');
        if (anchor && !anchor.closest('form') && anchor.nextElementSibling !== root) anchor.insertAdjacentElement('afterend',root);
      }
      function makeMessage(f) {
        function value(k) { return f[k] || 'No indicado'; }
        return ['SOLICITUD DE COTIZACIÓN POR VOLUMEN',
          'Referencia: ' + value('reference'), 'Fecha (Lima): ' + value('date_lima'),
          'Contacto: ' + value('name'), 'Empresa / razón social: ' + value('company'),
          'RUC: ' + value('ruc'), 'Correo: ' + value('email'), 'WhatsApp: ' + value('phone'),
          'Producto: ' + value('product'), 'SKU SB: ' + value('sku'),
          'Código fabricante / Barcode: ' + value('barcode'), 'Variante: ' + value('variant'),
          'Cantidad: ' + value('quantity'), 'Ciudad de entrega: ' + value('city'),
          'Observaciones / otros productos: ' + value('notes'), 'Enlace del producto: ' + value('url'),
          'Autorización de contacto: ' + value('consent'),
          'Solicitud informativa: precio y disponibilidad por confirmar.'].join('\n');
      }
      function setBusy(value) { busy = value; fieldsBox.disabled = value; form.setAttribute('aria-busy',String(value)); submitButton.textContent = value ? 'Registrando solicitud…' : submitLabel; }
      // POST in a hidden iframe: no PII in URLs and no unverified no-cors success.
      function sheetRequest(action) {
        return new Promise(function (resolve,reject) {
          if (!/^https:\/\/script\.google\.com\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(endpoint)) { reject(new Error('La conexión de registro no está configurada correctamente.')); return; }
          var sentRecord = record, nonce = randomId(), iframe = document.createElement('iframe'), post = document.createElement('form');
          iframe.name = 'sbv_' + nonce; iframe.hidden = true; iframe.title = 'Confirmación de registro';
          post.method = 'POST'; post.action = endpoint; post.target = iframe.name; post.hidden = true;
          var payload = document.createElement('input'); payload.type = 'hidden'; payload.name = 'payload';
          payload.value = JSON.stringify({version:2,action:action,origin:location.origin,nonce:nonce,time:sentRecord.time,fields:sentRecord.fields,message:sentRecord.message,website:get('website')});
          post.appendChild(payload);
          var done = false, timer;
          function finish(error,result) {
            if (done) return; done = true; clearTimeout(timer); window.removeEventListener('message',receive);
            iframe.remove(); post.remove(); if (error) reject(error); else resolve(result);
          }
          function receive(event) {
            if (!/^https:\/\/(?:script\.google\.com|[a-z0-9-]+\.googleusercontent\.com)$/i.test(event.origin)) return;
            var d = event.data;
            if (!d || d.type !== 'sb-volume-sheet-v2' || d.nonce !== nonce || d.reference !== sentRecord.fields.reference || d.action !== action) return;
            if (d.ok === true) finish(null,d); else finish(new Error('No se pudo confirmar el registro. Revisa tus datos y vuelve a intentarlo.'));
          }
          window.addEventListener('message',receive);
          timer = setTimeout(function () { finish(new Error('No se pudo confirmar el registro en Google Sheets. No se ha enviado todavía el correo. Pulsa enviar para reintentar sin duplicar la solicitud.')); },25000);
          document.body.appendChild(iframe); document.body.appendChild(post); post.submit();
        });
      }
      function emailStatus(text, retry) {
        root.querySelector('[data-sbv-email-status]').textContent = text;
        root.querySelector('[data-sbv-email-retry]').hidden = !retry;
      }
      // Receipt is confirmed by Sheets. Email is tracked independently and is not
      // marked as accepted merely because the quote has been saved.
      function success(emailAccepted) {
        setBusy(false);
        root.dataset.sbvCompleted = 'true';
        fieldsBox.hidden = true; root.querySelector('[data-sbv-success]').hidden = false;
        var wa = root.querySelector('[data-sbv-whatsapp]'), summary = root.querySelector('[data-sbv-message]');
        wa.disabled = !record; root.querySelector('[data-sbv-copy]').disabled = !record;
        root.querySelector('[data-sbv-storage-note]').hidden = Boolean(record);
        if (record) {
          if (emailAccepted === true) {
            record.emailAccepted = true; record.emailSubmitState = 'accepted';
            clearTimeout(emailTimer); nativePass = false;
          }
          persist();
          root.dataset.sbvStage = record.emailAccepted ? 'email-accepted' : 'saved';
          emailStatus(record.emailAccepted ? 'Shopify confirmó el procesamiento del aviso por correo.' : 'Tu solicitud está registrada. El aviso por correo aún no está confirmado.', !record.emailAccepted);
          root.querySelector('[data-sbv-reference]').textContent = 'Referencia: ' + record.fields.reference;
          summary.value = record.message;
          if (endpoint && record.sheetSaved && record.emailAccepted && !record.emailMarked) {
            var completedRecord = record;
            sheetRequest('email').then(function () { if (record !== completedRecord) return; record.emailMarked = true; persist(); }).catch(function () {
              if (record !== completedRecord) return;
              record.emailMarkPending = true; persist();
            });
          }
        }
        reveal(true);
      }
      function sendNative() {
        if (!record || record.emailAccepted || (endpoint && !record.sheetSaved)) return;
        clearTimeout(emailTimer);
        // Re-enable all controls before posting; disabled fieldsets are omitted
        // from HTML form submissions. Keep the original Shopify contact form,
        // action, security inputs and CAPTCHA handlers intact.
        setBusy(false);
        restoreFields();
        put('body',record.message);
        if (!form.checkValidity()) {
          fieldsBox.hidden = false; root.querySelector('[data-sbv-success]').hidden = true;
          delete root.dataset.sbvCompleted;
          notice('La solicitud está guardada. Revisa los campos indicados antes de enviar el aviso por correo.');
          form.reportValidity(); return;
        }
        var back = new URL(location.pathname,location.origin), params = new URLSearchParams(location.search);
        ['preview_theme_id','variant'].forEach(function (k) { if (params.has(k)) back.searchParams.set(k,params.get(k)); });
        back.searchParams.set('sb_volume_quote','1'); back.hash = form.id;
        var ret = form.querySelector('input[name="return_to"]');
        if (ret) ret.value = back.pathname + back.search + back.hash;
        record.emailSubmitState = 'sending'; record.emailAttemptedAt = Date.now();
        if (!persist()) return;
        root.dataset.sbvStage = 'email-pending';
        emailStatus('Procesando el aviso por correo. Completa la comprobación de seguridad de Shopify si aparece.',false);
        notice('Enviando a Shopify. Completa la comprobación de seguridad si aparece.');
        busy = true; form.setAttribute('aria-busy','true');
        emailTimer = setTimeout(function () {
          nativePass = false; setBusy(false);
          if (!record || record.emailAccepted) return;
          record.emailSubmitState = 'unconfirmed'; persist();
          emailStatus('Tu solicitud ya está registrada. No hemos podido confirmar el aviso por correo; puedes continuar por WhatsApp.',true);
          if (record.sheetSaved) success(false);
          else notice('Shopify no ha confirmado el envío. Revisa la comprobación de seguridad o vuelve a intentarlo.');
        },20000);
        try {
          // Keep pass-through enabled for Shopify CAPTCHA's own resubmissions;
          // a one-use flag could intercept those and restart the saving stage.
          nativePass = true; form.requestSubmit(submitButton);
        } catch (error) {
          clearTimeout(emailTimer); nativePass = false; setBusy(false);
          record.emailSubmitState = 'unconfirmed'; persist();
          emailStatus('Tu solicitud está registrada, pero no se pudo iniciar el aviso por correo. Puedes continuar por WhatsApp.',true);
          notice('No se pudo iniciar el envío por correo. Tus datos se conservan.');
        }
      }
      root.querySelector('[data-sbv-email-retry]').addEventListener('click',function () {
        if (!busy && record && record.sheetSaved && !record.emailAccepted) sendNative();
      });
      root.querySelector('[data-sbv-close]').addEventListener('click',close);
      root.querySelector('[data-sbv-whatsapp]').setAttribute('aria-label','Continuar por WhatsApp (se abre en otra pestaña)');
      root.querySelector('[data-sbv-whatsapp]').setAttribute('title','Se abre en otra pestaña sin cerrar este producto');
      root.querySelector('[data-sbv-whatsapp]').addEventListener('click',function () {
        if (!record) return;
        var number = (root.dataset.whatsapp || '').replace(/\D/g,'');
        if (!/^[1-9][0-9]{7,14}$/.test(number)) return;
        window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(record.message), '_blank', 'noopener,noreferrer');
      });
      root.querySelector('[data-sbv-copy]').addEventListener('click',function () {
        if (!record) return;
        var output = root.querySelector('[data-sbv-copy-status]');
        function fallback() { root.querySelector('details').open = true; var text = root.querySelector('[data-sbv-message]'); text.focus(); text.select(); output.textContent = 'Selecciona y copia el mensaje mostrado.'; }
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(record.message).then(function () { output.textContent = 'Mensaje completo copiado.'; }).catch(fallback);
        else fallback();
      });
      root.querySelector('[data-sbv-new]').addEventListener('click',function () {
        if (busy) return; clearTimeout(emailTimer); nativePass = false; forget(); record = null; form.reset(); fieldsBox.hidden = false; delete root.dataset.sbvStage;
        root.querySelector('[data-sbv-success]').hidden = true; delete root.dataset.sbvCompleted;
        root.querySelector('[data-sbv-message]').value = '';
        root.querySelector('[data-sbv-copy-status]').textContent = '';
        root.querySelector('details').open = false; put('reference',''); put('date_lima','');
        ['purchase_date','notes_input'].forEach(function (k) { field(k).setCustomValidity(''); });
        put('contact_method','');
        notice(''); sync(true); field('name').focus();
      });
      ['ruc','phone','name','quantity','purchase_date','notes_input'].forEach(function (key) { field(key).addEventListener('input',function () { this.setCustomValidity(''); }); });
      root.querySelectorAll('[data-sbv-contact-method]').forEach(function (box) {
        box.addEventListener('change',function () { put('contact_method',selectedContactMethods().join(', ')); });
      });
      form.addEventListener('submit',function (event) {
        if (nativePass) return;
        event.preventDefault(); event.stopImmediatePropagation(); if (busy) return;
        sync(false);
        var phone = get('phone').replace(/[\s().-]/g,'');
        if (/^9[0-9]{8}$/.test(phone)) phone = '+51' + phone;
        else if (/^[1-9][0-9]{7,14}$/.test(phone)) phone = '+' + phone;
        put('phone',phone); put('ruc',get('ruc')); put('name',get('name')); put('email',get('email'));
        field('phone').setCustomValidity(/^\+[1-9][0-9]{7,14}$/.test(phone) ? '' : 'Ingresa un WhatsApp válido con código de país.');
        field('ruc').setCustomValidity(/^[0-9]{11}$/.test(get('ruc')) ? '' : 'El RUC es obligatorio y debe tener exactamente 11 dígitos.');
        field('name').setCustomValidity(get('name') ? '' : 'Ingresa tu nombre.');
        field('quantity').setCustomValidity(Number.isSafeInteger(Number(get('quantity'))) && Number(get('quantity')) > 0 ? '' : 'Ingresa una cantidad entera mayor que cero.');
        preparePurchaseDetails();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        put('quantity',String(Number(get('quantity'))));
        if (get('website')) { notice('No se pudo validar la solicitud.'); return; }
        var values = {}; keys.forEach(function (k) { values[k] = get(k); });
        var changed = !record || Date.now() - record.time >= ttl || keys.some(function (k) { return k !== 'reference' && k !== 'date_lima' && values[k] !== record.fields[k]; });
        if (changed) {
          var now = Date.now();
          values.reference = 'SB-VOL-' + new Date(now).toISOString().slice(0,10).replace(/-/g,'') + '-' + randomId().slice(0,16).toUpperCase();
          values.date_lima = new Date(now).toLocaleString('es-PE',{timeZone:'America/Lima',hour12:false});
          record = {time:now,product:root.dataset.product,fields:values,message:makeMessage(values),sheetSaved:false,emailAccepted:false};
        }
        put('reference',record.fields.reference); put('date_lima',record.fields.date_lima); put('body',record.message);
        if (!persist()) return;
        var back = new URL(location.pathname,location.origin), params = new URLSearchParams(location.search);
        ['preview_theme_id','variant'].forEach(function (k) { if (params.has(k)) back.searchParams.set(k,params.get(k)); });
        back.searchParams.set('sb_volume_quote','1'); back.hash = form.id;
        var ret = form.querySelector('input[name="return_to"]'); if (ret) ret.value = back.pathname + back.search + back.hash;
        if (!endpoint) { sendNative(); return; }
        setBusy(true); root.dataset.sbvStage = 'saving'; notice('Registrando la solicitud…');
        sheetRequest('save').then(function () {
          record.sheetSaved = true;
          // Show the requested confirmation immediately after a verified save.
          // On Shopify's return page, restore this same receipt, not the form.
          if (!persist()) { setBusy(false); return; }
          success(false); sendNative();
        }).catch(function (error) { setBusy(false); notice(error.message); });
      },true);
      bind(); sync(true); record = read();
      if (record) restoreFields();
      var serverOK = root.querySelector('[data-sbv-server-success]').textContent.trim() === 'true';
      var serverErrors = root.querySelector('[data-sbv-errors]');
      if (record && record.sheetSaved) {
        if (record.emailSubmitState === 'sending') record.emailSubmitState = 'unconfirmed';
        success(!serverErrors && serverOK);
        if (serverErrors) emailStatus('La solicitud está registrada, pero Shopify devolvió un error al enviar el aviso por correo. Puedes continuar por WhatsApp.',true);
      } else if (!serverErrors && (serverOK && (record || new URLSearchParams(location.search).get('sb_volume_quote') === '1') || record && record.emailAccepted)) success(serverOK);
      else if (record || serverErrors) reveal(false);
      var i = info(); if (i) i.addEventListener('change',function () { if (!fieldsBox.hidden && !busy) sync(false); });
      window.addEventListener('pageshow',function (event) {
        // Do not erase errors on pageshow. A browser history restore must also
        // preserve the saved receipt without automatically sending more email.
        if (event.persisted && record && record.sheetSaved) {
          clearTimeout(emailTimer); nativePass = false;
          success(false);
        }
      });
      if (record) { clearTimeout(purgeTimer); purgeTimer = setTimeout(forget,Math.max(0,ttl - (Date.now() - record.time))); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();
